<template>
  <main class="download-page bg-white py-16 min-h-screen">


    <!-- Showcase section: phones left, text + downloads right -->
    <div class="mt-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <!-- Left: phone visuals -->
          <div class="phones-col flex justify-center">
            <div class="phone-stack" aria-hidden="true">
              <img :src="getImageUrl('image_mobile_showcase', '/assets/image3.png')" class="phone-back" :alt="getContent('download_mobile_showcase_alt', 'Mobile app showcase')">
              <img :src="getImageUrl('image_mobile_showcase', '/assets/image3.png')" class="phone-front" :alt="getContent('download_mobile_showcase_alt', 'Mobile app showcase')">
            </div>
          </div>

          <!-- Right: title, subtitle, features, download guides -->
          <div class="text-col">
            <h2 class="text-2xl lg:text-3xl font-bold mb-2">{{ mobileTitle }}</h2>
            <p class="text-base text-gray-900 mb-6">{{ getContent('download_mobile_subtitle', '探索投资艺术，激发投资灵感') }}</p>

            <div class="features mb-6">
              <div class="feature-item">
                <div class="feature-title">{{ getContent('download_feature_panorama_title', '全景模式') }}</div>
                <div class="feature-desc">{{ getContent('download_feature_panorama_desc', '综合评分全景扫描，1分钟了解企业基本面。') }}</div>
              </div>
              <div class="feature-item">
                <div class="feature-title">{{ getContent('download_feature_supply_chain_title', '企业供应链') }}</div>
                <div class="feature-desc">{{ getContent('download_feature_supply_chain_desc', '独特的企业供应链分析，通过企业供应商、客户、竞争对手发现投资机会。') }}</div>
              </div>
              <div class="feature-item">
                <div class="feature-title">{{ getContent('download_feature_live_trading_title', 'Live Trading') }}</div>
                <div class="feature-desc">{{ getContent('download_feature_live_trading_desc', '交易下单快如闪电，在线聊天投资不孤单。') }}</div>
              </div>
            </div>

            <!-- compact download guides -->
            <div class="download-grid grid grid-cols-2 gap-3">
              <a :href="getLinkUrl('download_app_store_url')" class="download-btn flex items-center gap-3 p-2 bg-white border border-gray-200 rounded-md shadow-sm hover:shadow-md" role="button" aria-label="Download on the Apple Store">
                <span class="btn-icon flex items-center justify-center w-8 h-8 rounded bg-black/5">
                  <img :src="getImageUrl('image_app_store_icon', '/assets/icon1.png')" :alt="getContent('download_app_store_alt', 'Apple Store')">
                </span>
                <span class="text-left">
                  <div class="text-xs text-gray-600">App Store 苹果</div>
                </span>
              </a>
              <a :href="getLinkUrl('download_pwa_url')" class="download-btn flex items-center gap-3 p-2 bg-white border border-gray-200 rounded-md shadow-sm hover:shadow-md" role="button" aria-label="PWA App Install">
                <span class="btn-icon flex items-center justify-center w-8 h-8 rounded bg-black/5">
                  <img src="@/assets/wecom-temp-67205-2c6ebfc4b7108c3cc4f6a5510275af26.png" :alt="getContent('download_pwa_alt', 'PWA Install')">
                </span>
                <span class="text-left">
                  <div class="text-xs text-gray-600">Google Play 安卓 </div>
                </span>
              </a>
              <a :href="getLinkUrl('download_apk_url')" class="download-btn flex items-center gap-3 p-2 bg-white border border-gray-200 rounded-md shadow-sm hover:shadow-md" role="button" aria-label="APK Download">
                <span class="btn-icon flex items-center justify-center w-8 h-8 rounded bg-black/5">
                  <img :src="getImageUrl('image_apk_icon', '/assets/icon3.png')" :alt="getContent('download_apk_alt', 'APK Download')">
                </span>
                <span class="text-left">
                  <div class="text-xs text-gray-600">安卓 APK 下载</div>
                </span>
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Desktop showcase: text and image in same row -->
  </main>
</template>

<script>
import { ContentMixin } from '../services/contentService'

export default {
  name: 'DownloadPage',
  mixins: [ContentMixin],
  data() {
    return {
      currentLocale: localStorage.getItem('locale') || 'zh'
    }
  },
  computed: {
    currentLang() {
      // 从localStorage获取当前语言，映射到API格式
      const langMap = {
        'zh': 'cn',
        'zh-Hant': 'tw',
        'en': 'en'
      };
      return langMap[this.currentLocale] || 'cn';
    },
    mobileTitle() {
      const fallbackByLang = {
        cn: '红土证券移动端交易平台',
        en: 'Redland Securities Mobile Trading Platform',
        tw: '紅土證券移動端交易平台'
      };

      const currentLang = this.currentLang;
      const fallback = fallbackByLang[currentLang] || fallbackByLang.cn;
      const rawTitle = this.getContent('download_mobile_title', fallback);

      if (typeof rawTitle !== 'string' || !rawTitle.trim()) {
        return fallback;
      }

      const brandByLang = {
        cn: '红土证券',
        en: 'Redland Securities',
        tw: '紅土證券'
      };

      const replaced = rawTitle.trim().replace(/Longbridge/gi, brandByLang[currentLang] || brandByLang.cn);

      if (currentLang === 'cn') {
        return replaced
          .replace(/红土\s*证券/g, '红土证券')
          .replace(/红土证券\s+/g, '红土证券');
      }

      if (currentLang === 'tw') {
        return replaced
          .replace(/紅土\s*證券/g, '紅土證券')
          .replace(/紅土證券\s+/g, '紅土證券');
      }

      return replaced;
    }
  },
  async created() {
    // 加载下载页面的内容
    await this.loadCategoryContent('download');

    // 监听语言切换事件
    window.addEventListener('localeChange', this.handleLocaleChange);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('localeChange', this.handleLocaleChange);
  },
  methods: {
    handleLocaleChange(event) {
      // 更新当前语言
      this.currentLocale = event.detail.locale;
      // 语言切换时重新加载下载页面内容
      this.loadCategoryContent('download');
    }
  }
}
</script>

<style scoped>
.guide .icon { font-weight: 700; color: rgba(0,0,0,0.6); }
.devices { height: 320px; }
.device-desktop { background-image: linear-gradient(180deg,#f9fafb,#f3f4f6); }
.device-phone { background-image: linear-gradient(180deg,#ffffff,#f8fafc); left: 8%; }
.device-tablet { background-image: linear-gradient(180deg,#ffffff,#f8fafc); right: 8%; }
.stat-underline { background: #ef7c5b; }
/* Showcase phone stack */
.phone-stack { position: relative; width: 320px; height: 420px; }
.phone-stack img { position: absolute; border-radius: 18px; box-shadow: 0 12px 30px rgba(16,24,40,0.12); object-fit: cover; }
.phone-stack .phone-back { width: 220px; left: 20px; top: 30px; transform: rotate(-8deg); }
.phone-stack .phone-front { width: 180px; right: 10px; bottom: 0; transform: rotate(6deg); }
.feature-item { margin-bottom: 1rem; }
.feature-item .feature-title { font-weight: 600; margin-bottom: 6px; }
.feature-item .feature-desc { color: rgba(31,41,55,0.85); font-size: 0.95rem; line-height: 1.4; }
</style>


